import { render } from "./HomeFooter.vue?vue&type=template&id=6e997d2c&scoped=true"
import script from "./HomeFooter.vue?vue&type=script&lang=js"
export * from "./HomeFooter.vue?vue&type=script&lang=js"

import "./HomeFooter.vue?vue&type=style&index=0&id=6e997d2c&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e997d2c"]])

export default __exports__